<template>
  <div class="company-form-preview">
    <InvestorsPageContent :investor="investor" />
  </div>
</template>

<script>
import InvestorsPageContent from '@/components/investors/InvestorsPageContent'

export default {
  name: 'InvestorFormPreview',
  components: {
    InvestorsPageContent
  },
  props: {
    investor: {
      type: Object,
      required: true
    }
  }
}
</script>
